<div class="container" *ngIf="!loading; else loadingComponent">
  <div class="row">
    <div class="col-md-12">
      <app-header *ngIf="companyData" [companyData]="companyData"></app-header>

      <div class="container feedbackForm py-3">
        <div class="row">
          <!-- <div class="col-md-12 border-bottom">
            <div class="row font500 font16">
              <div class="col-md-4">
                <p class="mb-0 pt-2  pb-2">Order No: <span class="customPurple float-right">#45565566</span></p>
              </div>
              <div class="col-md-4 border-left border-right">
                <p class="mb-0 pt-2 pb-2">Order Time: <span class="customPurple float-right">24-06-2022, 07:36 PM</span></p>
              </div>
              <div class="col-md-4">
                <p class="mb-0 pt-2 pb-2">Order Details: <span class="customPurple float-right">Click Here</span></p>
              </div>
            </div>
          </div> -->
          <div class="col-md-12" *ngIf="!feedbackSubmit">
            <p class="font18 text-center font500 customPurple">
              CUSTOMER FEEDBACK FORM
            </p>

            <!-- <div class="userImage mt-3">
              <p><b>Staff</b></p>
              <img src="./user.jpg" alt="">
              <p class="mt-2 font16">Ram Lal</p>
            </div> -->

            <div class="modal-rating-background pt-2">
              <div class="col-md-12 text-center">
                <span><b>How Was Your Experience ?</b></span>
              </div>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-7">
                    <fieldset class="rating">
                      <input type="radio" id="star5" name="rating" value="5.0" (click)="onStarClick()" />
                      <label class="full" for="star5" title="Awesome - 5 stars"></label>
                      <input type="radio" id="star4" name="rating" value="4.0" (click)="onStarClick()" />
                      <label class="full" for="star4" title="Pretty good - 4 stars"></label>
                      <input type="radio" id="star3" name="rating" value="3.0" (click)="onStarClick()" />
                      <label class="full" for="star3" title="Meh - 3 stars"></label>
                      <input type="radio" id="star2" name="rating" value="2.0" (click)="onStarClick()" />
                      <label class="full" for="star2" title="Kinda bad - 2 stars"></label>
                      <input type="radio" id="star1" name="rating" value="1.0" (click)="onStarClick()" />
                      <label class="full" for="star1" title="Sucks big time - 1 star"></label>
                      <input type="radio" class="reset-option" name="rating" value="reset" />
                    </fieldset>
                  </div>
                  <div class="col-md-5 rating-output mt-2">
                    <span>
                      <p class="myratings">{{ rating }}</p>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 custom-text-color pt-3" *ngIf="checkboxList">
                <div class="custom-control custom-checkbox" *ngFor="let cbox of checkboxList; let i = index">
                  <input type="checkbox" class="custom-control-input" id="{{ cbox.RatingParamID }}"
                    (click)="toggleCheckbox(i)" [(ngModel)]="cbox.checked" />
                  <label class="custom-control-label checkbox-label" for="{{ cbox.RatingParamID }}">
                    <p class="m-0 ps-2">{{ cbox.RatingParameter }}</p>
                  </label>
                </div>
              </div>
            </div>

            <div class="mt-4 pb-2">
              <b>Write your review</b>
            </div>

            <div class="form-group">
              <p class="wizardFormHeading mb-1"></p>
              <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" [(ngModel)]="comments"
                placeholder="Comments"></textarea>
            </div>

            <div class="pt-3">
              <b>Add Photos</b>
            </div>

            <div class="dropImg" *ngIf="!image">
              <i class="fa-solid fa-cloud-arrow-up"></i>
              <input type="file" (change)="previewImages($event)" />
            </div>
            <div class="imagePreview mt-2" *ngIf="image">
              <img [src]="image" /><i class="fa-solid fa-circle-xmark imageDelete" (click)="removeImage()"></i>
            </div>
            <!-- <div class="col-3 p-0 pt-2 mb-2">
              <span class="btn btn-lg prepend-background fileinput-button" *ngIf="!image">
                <span><i class="fa fa-2x fas fa-camera p-2"></i></span>
                <input type="file" (change)="previewImages($event)"><br />
              </span>
              <div id="image_preview" *ngIf="image">
                <div class="row">
                  <img [src]="image"><i class="fa-solid fa-circle-xmark imageDelete" (click)="removeImage()"></i>
                </div>
              </div>
            </div> -->

            <div class="clearfix"></div>

            <div class="pt-3" *ngIf="staffList?.length>1">
              <b>Mention Staff by name</b>
            </div>

            <div class="mt-3" *ngIf="staffList?.length>1">
              <div class="staffImages">
                <p>
                  <a class="btn btn-danger submitButton" data-bs-toggle="collapse" href="#collapseExample" role="button"
                    aria-expanded="false" aria-controls="collapseExample">
                    Show Staff <i class="fa-solid fa-angle-down pl-3"></i>
                  </a>
                </p>
                <div class="collapse" id="collapseExample">
                  <div class="card card-body">
                    <div class="staffList">
                      <div class="row scrollOffer">
                        <div class="col-6 col-md-3 manualOffer" *ngFor="let staff of staffList"
                          [ngClass]="{ selected: staff.isSelected }">
                          <div class="card w-100 borderRadius10">
                            <div class="card-body text-center" (click)="deleteMe(staff.MemberID)">
                              <img *ngIf="staff.PhotoURL" [src]="staff.PhotoURL" class="img-fluid rounded-circle"
                                alt="specialist" id="s" />
                              <img *ngIf="!staff.PhotoURL"
                                src="https://dkzxkcjlbnjui.cloudfront.net/uploads/media/images/user-image.png "
                                class="img-fluid rounded-circle" alt="specialist" id="s" />
                              <p class="blackText mb-0 mt-3">
                                {{ staff.FullName }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12 customerDetails mt-4">
              <form [formGroup]="FeedbackForm" onsubmit="false" class="frmwzrd" *ngIf="loginData">
                <div class="instaWizard">
                  <div class="row mt-2">
                    <div class="col-md-12 p-0">
                      <div class="row">
                        <div class="col-12 form-group">
                          <p class="wizardFormHeading mb-1 pt-3 mb-1">
                            Your Name
                          </p>
                          <input type="email" class="form-control formHeight" id="inputName"
                            placeholder="Your full name" formControlName="Name" />
                          <p style="color: red" *ngIf="
                              FeedbackForm.controls['Name'].invalid &&
                              FeedbackForm.controls['Name'].touched
                            ">
                            Please Enter Name
                          </p>
                        </div>
                        <div class="col-12 form-group">
                          <p class="wizardFormHeading mb-1 pt-3 mb-1">
                            Your Email
                          </p>
                          <input type="email" class="form-control formHeight" id="inputEmail"
                            placeholder="Your email address" formControlName="Email" />
                          <p style="color: red" *ngIf="
                              FeedbackForm.controls['Email'].invalid &&
                              FeedbackForm.controls['Email'].touched &&
                              FeedbackForm.controls['Email'].errors.required
                            ">
                            Please Enter Email
                          </p>
                          <p style="color: red" *ngIf="
                              FeedbackForm.controls['Email'].invalid &&
                              FeedbackForm.controls['Email'].touched &&
                              FeedbackForm.controls['Email'].errors.pattern
                            ">
                            Please Enter valid Email
                          </p>
                        </div>
                        <div class="col-12 form-group">
                          <p class="wizardFormHeading mb-1 pt-3 mb-1">
                            Your Phone
                          </p>
                          <input type="text" class="form-control formHeight" id="inputPhone"
                            placeholder="Your mobile number" formControlName="Phone"
                            onkeypress="return event.keyCode >= 48 && event.keyCode <= 57"
                            [maxlength]="loginData['MobileNumberLength']" />
                          <p style="color: red" *ngIf="
                              FeedbackForm.controls['Phone'].invalid &&
                              FeedbackForm.controls['Phone'].touched &&
                              FeedbackForm.controls['Phone'].errors.required
                            ">
                            Please Enter Phone
                          </p>
                          <p style="color: red" *ngIf="
                              FeedbackForm.controls['Phone'].invalid &&
                              FeedbackForm.controls['Phone'].touched &&
                              (FeedbackForm.controls['Phone'].hasError(
                                'minlength'
                              ) ||
                                FeedbackForm.controls['Phone'].hasError(
                                  'maxlength'
                                ))
                            ">
                            Phone number length must be
                            {{ loginData?.MobileNumberLength }}
                          </p>
                        </div>
                      </div>

                      <div class="d-grid mt-4">
                        <button type="submit" class="btn submitButton buttonheight" (click)="onSubmit()">
                          <i class="fas fa-check-circle mr-3"></i>
                          Submit your feedback
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="col-md-12 text-center acknowledgmentMessage" *ngIf="feedbackSubmit">
            <img src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti/icon/check-mark.png" alt="" />
            <h4 class="text-success px-4" >
              Thank you, Your Feedback has been submitted.
            </h4>
          </div>
        </div>
      </div>
      <app-footer></app-footer>
    </div>
  </div>
</div>

<button style="display: none" #myloginModal data-bs-toggle="modal" data-bs-target="#myloginModal"></button>
<!-- Login Model Starts -->
<div class="modal fade" id="myloginModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modelClose text-end">
        <button type="button" data-bs-dismiss="modal" aria-label="Close" class="close background-none" #loginModalClose>
          <i class="fas fa-times-circle"></i>
        </button>
      </div>
      <div class="modal-body">
        <ng-container *ngIf="this.loginData && this.loginData['SMSActivated']">
          <div class="modelImage text-center">
            <img src="https://dkzxkcjlbnjui.cloudfront.net/uploads/media/logo/bigdot-logo.png" alt=""
              class="modelLogo" />
          </div>
          <div *ngIf="this.loginData['SMSActivated'] === 'Y'" class="input-group my-4">
            <span class="input-group-text formHeight" id="basic-addon1">
              <i class="fas fa-phone primaryColor font22"></i>
            </span>
            <input type="text" class="form-control" placeholder="Enter phone number" aria-label="Mobile"
              aria-describedby="basic-addon1" [(ngModel)]="MobileNumber" id="login" name="Mobile" maxlength="10" />
          </div>
          <div *ngIf="this.loginData['SMSActivated'] === 'N'" class="input-group my-4">
            <span class="input-group-text formHeight" id="basic-addon1">
              <i class="fas fa-envelope primaryColor font22"></i>
            </span>
            <input type="text" class="form-control" placeholder="Enter email address" aria-label="EmailID"
              aria-describedby="basic-addon1" [(ngModel)]="EmailID" id="login" name="Email" />
          </div>
          <div style="color: red; padding-left: 5px" *ngIf="errorMessage">
            {{ errorMessage }}
          </div>
          <div class="d-grid">
            <button class="btn text-white font16 font500 primaryBgColor buttonHeight" (click)="getOtpMobile(true)">
              Submit
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<!-- Login Model Ends -->

<button #otpModalButton style="display: none" data-bs-toggle="modal" data-bs-target="#otpModal"></button>
<!-- OTP Modal Starts-->
<div class="modal fade" id="otpModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modelClose text-end">
        <button type="button" data-bs-dismiss="modal" aria-label="Close" class="close background-none" #otpModalClose>
          <i class="fas fa-times-circle"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="modelImage text-center">
          <img src="https://dkzxkcjlbnjui.cloudfront.net/uploads/media/logo/bigdot-logo.png" alt="" class="modelLogo" />
        </div>
        <div class="otpHeading text-center pt-4 pb-3">
          <h4>VERIFY OTP</h4>
        </div>
        <div class="otpField pb-3">
          <input [(ngModel)]="EnteredOTP" type="text" onkeypress="return event.keyCode >= 48 && event.keyCode <= 57"
            class="form-control text-center formHeight" id="inputPassword" placeholder="Enter OTP" maxlength="4" />
        </div>
        <div class="pl-2" style="color: red; padding-left: 5px" *ngIf="errorMessage">
          {{ errorMessage }}
        </div>
        <div class="d-grid">
          <button class="btn text-white font16 font500 primaryBgColor buttonHeight" (click)="verifyOtp()">
            Verify
          </button>
          <p class="text-center pt-3">Check your SMS and enter OTP here.</p>
        </div>
        <div class="resendOTP text-center pt-2 pb-2">
          <a class="text-decoration-none" *ngIf="sendingOtp">Sending OTP...</a>
          <a class="text-decoration-none" *ngIf="otpSent">
            OTP sent successfully. Resend OTP in {{ secondsToDelay }} seconds</a>
          <a class="text-decoration-none" style="cursor: pointer" (click)="getOtpMobile(false)"
            *ngIf="!otpSent && !sendingOtp">Resend OTP</a>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- OTP Modal Ends-->

<button #openloginname style="display: none" data-bs-toggle="modal" data-bs-target="#nameModal"></button>
<!-- Enter Name Model Starts-->
<div class="modal fade" id="nameModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modelClose text-end">
        <button type="button" data-bs-dismiss="modal" aria-label="Close" class="close background-none" #nameModalClose>
          <i class="fas fa-times-circle"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="modelImage text-center">
          <img src="https://dkzxkcjlbnjui.cloudfront.net/uploads/media/logo/bigdot-logo.png" alt="" class="modelLogo" />
        </div>
        <div>
          <div class="col-md-12 p-0">
            <label for="inputEmail4" class="form-label">Your Name</label>
            <input type="email" class="form-control" [(ngModel)]="CitizenName" id="inputEmail4"
              placeholder="Enter your name" />
          </div>
          <div class="d-grid mt-2">
            <button class="btn text-white font16 font500 primaryBgColor buttonHeight" (click)="OnSaveName()">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Enter Name Model Ends-->
<ng-template #loadingComponent>
  <div class="d-flex justify-content-center align-items-center">
    <img src="https://dkzxkcjlbnjui.cloudfront.net/portal/loader/loading-page.gif" style="padding-top: 10%" />
  </div>
</ng-template>